import type { ReactNode } from 'react';
import classNames from 'classnames';
import type { CompositeWellboreLeg } from './types';
import styles from './composite-leg-lines.module.scss';

export interface CompositeLegLinesProps {
  /** The composite wellbore's legs, in drilling order. */
  legs: CompositeWellboreLeg[];
  /** What a leg's line shows: its formation, its curve with an edit control, its status. */
  render: (leg: CompositeWellboreLeg) => ReactNode;
  className?: string;
}

/**
 * A composite wellbore's cell: one line per leg, in drilling order. The Formation, Volume
 * Source and Forecast Status columns all render it, since a well whose legs are each priced
 * on their own formation's curve has one value per leg for each; the row's other columns
 * (dates, AFE, schedule) stay the well's. Rows grow to fit — the table measures a row that
 * wraps.
 *
 * @param {CompositeLegLinesProps} props - The legs and how to render one.
 * @return {JSX.Element} The lines.
 */
export function CompositeLegLines({
  legs,
  render,
  className,
}: CompositeLegLinesProps) {
  return (
    <ul className={classNames(styles.lines, className)}>
      {legs.map((leg) => (
        <li key={leg.slotId} className={styles.line}>
          {render(leg)}
        </li>
      ))}
    </ul>
  );
}
